import React, { useCallback, useState } from 'react'
import T from '../../i18n/T'
import { withFrenchSite } from '../../i18n/i18nSite'
import { useSelector } from 'react-redux'
import { selectHomeWorkOrFakeFavorites } from '../../../store/suggest/suggest.selectors'
import { removeHtmlEmTags } from '../../../utils/string'
import { useAction } from '../../utils/react-redux'
import useIncentiveClick from '../../suggest/useIncentiveClick'
import { searchAddress } from '../../../store/address/address.actions'
import SuggestContentList from '../../suggest/SuggestContentList'
import { withOnlyGE } from '../../Device'
import { dispatchTag } from '../../../store/analytics/analytics.actions'
import useFavoritePushTagBuilder from './useFavoriteClickHandler'
import useKeycloak from '../useKeycloak'
import s from './FavoritesPush.less'

const FavoritesPushHp = () => {
  const { loaded } = useKeycloak()
  const homeWorkFavorites = useSelector(selectHomeWorkOrFakeFavorites)
  const [selectedId, setSelectedId] = useState(null)

  const updateSelectedId = idx => {
    setSelectedId(idx)
  }

  const execSearchAddress = useAction(searchAddress)
  const execDispatchTag = useAction(dispatchTag)

  const { favoritePushTabBuilder } = useFavoritePushTagBuilder()

  const onClick = useCallback(
    suggest => {
      execDispatchTag(favoritePushTabBuilder(suggest))

      const { labels, address } = suggest
      const label = removeHtmlEmTags(address || labels.join(' '))
      execSearchAddress({ terms: label })
    },
    [favoritePushTabBuilder]
  )

  const { onIncentiveClick } = useIncentiveClick({ onClick, incentiveTagClickBuilder: favoritePushTabBuilder })

  if (!loaded) return <></>

  return (
    <div className={s.FavoritesPushHp}>
      <div className={s.FavoritesPushTitle}>
        <span>
          <T id={'suggest.favorites.my-favorites'} />
        </span>
      </div>
      <SuggestContentList
        suggestions={homeWorkFavorites}
        onClick={onIncentiveClick}
        selectedId={selectedId}
        updateSelectedId={updateSelectedId}
      />
    </div>
  )
}
export default withFrenchSite(withOnlyGE(FavoritesPushHp))
